import { Asterisk } from "lucide-react";

const ITEMS = [
  "Mobile Detailing",
  "We Come To Your Home Or Work",
  "919-737-3526",
  "Basic Clean",
  "Full Detail",
  "Disaster Detail",
  "Pet Hair & Stain Specialists",
];

export default function MarqueeBanner() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-banner"
      className="relative border-y border-amber-500/25 bg-[#0B0D10] py-5 overflow-hidden"
    >
      <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-8">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8">
                <span className="font-syne font-bold uppercase tracking-wide text-lg sm:text-xl text-slate-200">
                  {item}
                </span>
                <Asterisk size={20} className="text-amber-500 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
